export default function asyncTimeout(duration) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, duration);
    });
}
